export default {
    login: '@:actions.login',
    settings: 'Meu Cadastro',
    logout: '@:actions.logout',
    welcome: 'Conheça',
}